import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import VectorStoreSync from './VectorStoreSync';

const VectorStorePage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          mb: 2,
          gap: 2,
          flexWrap: 'wrap',
        }}
      >
        <Box>
          <Typography variant="h4" gutterBottom>
            Vector Store
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Estadísticas, sincronización y limpieza del Vector Store a nivel global (multi‑proyecto).
          </Typography>
        </Box>

        <Button
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate('/projects')}
        >
          Volver a Proyectos
        </Button>
      </Box>

      <VectorStoreSync />
    </Box>
  );
};

export default VectorStorePage;

